import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as thunks from './thunks';

type State = {
  paymentTypes: string[];
};

const initialState: State = {
  paymentTypes: []
};

const slice = createSlice({
  name: 'paymentTypes',
  initialState,
  reducers: {
    setPaymentTypes(state, action: PayloadAction<string[]>) {
      state.paymentTypes = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.getPaymentTypesThunk.pending, (state) => {
      state.paymentTypes = [];
    });
    builder.addCase(thunks.getPaymentTypesThunk.fulfilled, (state, action) => {
      state.paymentTypes = action.payload.originalData.data || [];
    });
    builder.addCase(thunks.getPaymentTypesThunk.rejected, (state) => {
      state.paymentTypes = [];
    });
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
